import { createContext, useContext } from "solid-js";
const ListContext = createContext({
    dense: false,
});
export function useListContext() {
    return useContext(ListContext);
}
export default ListContext;
